// @flow

import { selectPricingInfos } from '@gandi/billing';
import { useResourceFetch } from '@gandi/resource/react';
import type { ResourceActionFetchOptions } from '@gandi/resource/redux';

import { usePreferences } from 'src/Layout/hooks';
import { useAppSelector } from 'src/hooks';
import {
  productsResource,
  type ProductsResourceType,
  type ProductSummary,
} from 'src/modules/mailbox-standalone/resources/products';

export function useProductsFetch(fetchOptions?: ResourceActionFetchOptions): {
  isFailure: boolean,
  isFetching: boolean,
  isForbidden: boolean,
  isLoaded: boolean,
  label: string,
  meta: ?ProductsResourceType['fetchMeta'],
  shouldFetch: boolean,
  summaries: ?Array<ProductSummary>,
} {
  const libPricingInfos = useAppSelector(selectPricingInfos);
  const preferences = usePreferences();

  // Use current site preferences if current orga doesn't have a prepaid account (and thus no pricing infos)
  const { grid = 'A', currency = 'EUR' } = {
    ...libPricingInfos,
    ...preferences,
  };

  return useResourceFetch(
    productsResource,
    { currency, grid, sellable: true },
    fetchOptions,
  );
}
